module.exports = __webpack_public_path__ + "assets/617cb4522b7ee46887a58a7e218780cc.mp3";